import styled from 'styled-components';

const StyledWrapper = styled.div`
  &:not(:nth-of-type(1)) {
    margin-top: 12px;
  }
`;

const FlexBox = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.$gap};
  margin: ${(props) => props.$margin};

  & label {
    width: 120px;
    font-size: 17px;
    font-weight: 500;
    line-height: 1.4;
    color: #0f0f0f;
  }

  & input {
    width: calc(100% - 120px);
    height: 56px;
    padding: 0 16px;
    font-size: 18px;
    line-height: 1.4;
    color: #0f0f0f;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    &::placeholder {
      color: #929292;
    }
  }
`;

function TextfieldBox(props) {
  return (
    <StyledWrapper>
      <FlexBox $gap="10px">
        <label htmlFor={props.id}>{props.label}</label>
        <input
          type="text"
          id={props.id}
          placeholder={`${props.label}`}
          value={props.value || ''}
          onChange={props.onChange}
        />
      </FlexBox>
    </StyledWrapper>
  );
}

export default TextfieldBox;
